// export const validDecimal = (value: string, restrictions: { numberLength: number; decimalLength: number }): boolean => {
//   const regex = new RegExp(
//     `^([0-9]{0,${restrictions.numberLength}}[.]{1}[0-9]{0,${restrictions.decimalLength}}|[0-9]{0,${restrictions.numberLength}})$`,
//   );
//   const validate = value.match(regex);
//   // Code: Uncomment to restrict overall length regardless of decimal place
//   // const length = value.replace(/[^0-9]/g, '').length <= restrictions.numberLength;
//   return validate !== null; // && length;
// };

import { missingField } from 'app/constants';

export const validDecimal = (
  value: string,
  restrictions: { numberLength: number; decimalLength: number; belowOne?: boolean; maxValue?: number },
): boolean => {
  const { numberLength, decimalLength, belowOne, maxValue } = restrictions;

  const regex = new RegExp(`^([0-9]{0,${numberLength}}[.]{1}[0-9]{0,${decimalLength}}|[0-9]{0,${numberLength}})$`);
  const validate = value.match(regex);

  const belowOneRegex = new RegExp(`^0(\\.\\d{0,${decimalLength}})?$`);
  const numericValue = parseFloat(value);

  if (!validate) return false;

  if (belowOne && !belowOneRegex.test(value)) return false; // Check for below one condition
  if (maxValue !== undefined && (numericValue < 0 || numericValue > maxValue)) return false; // Check max value

  return true;
};

export const validInteger = (value: string, restrictions: { numberLength: number }): boolean => {
  const regex = new RegExp(`^([0-9]{0,${restrictions.numberLength}})$`);
  const validate = value.match(regex);
  // Code: Uncomment to restrict overall length regardless of decimal place
  // const length = value.replace(/[^0-9]/g, '').length <= restrictions.numberLength;
  return validate !== null; // && length;
};

export const formatToAmericanNotaion = (num: number) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export function kFormatter(num: number, digits: number) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
  ];
  const regexExp = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });

  return item ? (num / item.value).toFixed(digits).replace(regexExp, '$1') + item.symbol : '0';
}

/**
 * Method to round off dollar values to 2 decimal points
 * @param value
 * @returns
 */
export const formatDollarValues = (value: number | string) => {
  const num = Number(value);
  return isFinite(num) ? num.toFixed(2) : '0.00';
};

/**
 * Formats a number to a string with specified number of decimal places
 * @param value - The number to format
 * @param fixedDigits - Number of decimal places (default: 2)
 * @returns Formatted string or empty string if value is null/undefined
 */
export const fixedNumberToString = (value?: number, fixedDigits: number = 2): string => {
  if (value === null || value === undefined) {
    return '';
  } else {
    return isNumber(value) ? `${value?.toFixed(fixedDigits)}` : '';
  }
};

/**
 * Formats a number:
 * - If it's an integer, return it with no decimals.
 * - If it has a fractional part, round to `fixedDigits` (default: 2).
 * Returns '' for null/undefined or non-finite numbers.
 */
export const formatIfFractional = (
  value?: number,
  fixedDigits: number = 2,
  prefix: string = '',
  enforceDecimal = false,
  postfix: string = '',
): string => {
  if (value == undefined || value == null || !Number.isFinite(value)) return missingField;

  // Normalize -0 to 0 for nicer output like "0" instead of "-0"
  const n = Object.is(value, -0) ? 0 : value;

  const val = Number.isInteger(n) && !enforceDecimal ? String(n) : n.toFixed(fixedDigits);
  return prefix ? `${prefix}${val}` : postfix ? `${val}${postfix}` : val;
};

/**
 * Helper function to check if value is a number
 * @param value - The value to check
 * @returns boolean indicating if value is a number
 */
const isNumber = (value: any): boolean => {
  return typeof value === 'number';
};
